require('@uirouter/angularjs');
require('angular/libs/hash-redirect.js');
require('angular');
require('angular-cookies');
require('angular-animate');
require('angular-resource');
require('angular-sanitize');
require('angular/libs/angular/ng-upload.js');
require('angular/libs/angular-strap/angular-strap');
require('angular/libs/angular-strap/modules/strapmodal.js');
require('angular/libs/angular-ui/ui-bootstrap-tpls-0.12.1.js');
require('angular/libs/other/slider.js');
require('angular/libs/angular-ui/ui-utils-0.1.1.js');
require('angular/libs/angular-ui/select2.js');
require('angular/libs/angular-snapscroll.coffee');
require('angular/libs/neuro_id/track-angular.js')
require('imports-loader?exports=>false!jquery.maskedinput/src/jquery.maskedinput.js');
require('angular/libs/pusher-angular/pusher.min.js')
require('pusher-angular')
require('angular/exception_handling/sentry.js');
require('cleave.js');
require('cleave.js/dist/addons/cleave-phone.us');

const _ = require('underscore');
window.lodash = window.lodash || {}
window.lodash.cloneDeep = require('lodash.clonedeep');
window.lodash.isEmpty = require('lodash.isempty');
window.lodash.merge = require('lodash.merge');
window.moment = require('moment');

_.mixin({
  isBlank: function(value) {
    return value && value.length;
  }
});
